export default "__VITE_ASSET__Cf2GPPQJ__"